module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_3009.a460db08.png";